// Line-icon shapes on a 24x24 grid. Plain data, no imports.
// Each entry is [tag, props]. They are drawn as strokes by AppIcon.js, so one
// `color` prop recolors the whole icon (emojis can't be recolored).
// Names match the fuel ids from the API: benzine, diesel, electric, lpg.
export const ICON_SHAPES = {
  // fuel pump
  benzine: [
    ['rect', {x: 4, y: 3, width: 9, height: 18, rx: 1.8}],
    ['rect', {x: 6.5, y: 6, width: 4, height: 4, rx: 0.8}],
    ['line', {x1: 2.5, y1: 21, x2: 14.5, y2: 21}],
    ['path', {d: 'M13 9h2.2A1.8 1.8 0 0 1 17 10.8V16a1.5 1.5 0 0 0 3 0V8.2L17.4 5.6'}],
  ],

  // jerrycan with a drop
  diesel: [
    ['rect', {x: 5.5, y: 7, width: 13, height: 14, rx: 2}],
    ['path', {d: 'M9 7V5.2A1.2 1.2 0 0 1 10.2 4h3.6A1.2 1.2 0 0 1 15 5.2V7'}],
    ['path', {d: 'M12 11.2c-1.5 1.9-2.4 3-2.4 4.1a2.4 2.4 0 0 0 4.8 0c0-1.1-.9-2.2-2.4-4.1z'}],
  ],

  // lightning bolt
  electric: [
    ['path', {d: 'M13 2.5 5.5 13.2h5.8l-.8 8.3 8-10.7h-5.8z'}],
  ],

  // gas cylinder
  lpg: [
    ['rect', {x: 6.5, y: 8, width: 11, height: 13, rx: 3.5}],
    ['path', {d: 'M10 8V6.2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V8'}],
    ['line', {x1: 12, y1: 5.2, x2: 12, y2: 3}],
    ['line', {x1: 10.2, y1: 3, x2: 13.8, y2: 3}],
    ['line', {x1: 6.5, y1: 13, x2: 17.5, y2: 13}],
  ],

  // car
  car: [
    ['path', {d: 'M5 12l1.6-4.2A1.5 1.5 0 0 1 8 6.8h8a1.5 1.5 0 0 1 1.4 1L19 12'}],
    ['rect', {x: 3.5, y: 12, width: 17, height: 6, rx: 2}],
    ['circle', {cx: 7.5, cy: 18, r: 1.6}],
    ['circle', {cx: 16.5, cy: 18, r: 1.6}],
  ],

  // car, seen from the front
  carFront: [
    ['path', {d: 'M6 11.5l1.5-4A1.5 1.5 0 0 1 8.9 6.5h6.2a1.5 1.5 0 0 1 1.4 1l1.5 4'}],
    ['rect', {x: 4, y: 11.5, width: 16, height: 6, rx: 2}],
    ['circle', {cx: 7.8, cy: 14.5, r: 0.7}],
    ['circle', {cx: 16.2, cy: 14.5, r: 0.7}],
    ['line', {x1: 7, y1: 17.5, x2: 7, y2: 19.5}],
    ['line', {x1: 17, y1: 17.5, x2: 17, y2: 19.5}],
  ],

  // briefcase
  briefcase: [
    ['rect', {x: 3, y: 7, width: 18, height: 13, rx: 2}],
    ['path', {d: 'M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7'}],
    ['line', {x1: 3, y1: 13, x2: 21, y2: 13}],
    ['line', {x1: 12, y1: 12, x2: 12, y2: 14.5}],
  ],

  // light bulb
  bulb: [
    ['path', {d: 'M12 3a6 6 0 0 0-3.6 10.8c.7.6 1.1 1.3 1.1 2.2v.5h5V16c0-.9.4-1.6 1.1-2.2A6 6 0 0 0 12 3z'}],
    ['line', {x1: 9.5, y1: 19, x2: 14.5, y2: 19}],
    ['line', {x1: 10.5, y1: 21.5, x2: 13.5, y2: 21.5}],
  ],

  // star
  star: [
    ['path', {d: 'M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.5 6.6 19.5l1.2-6L3.3 9.3l6.1-.7z'}],
  ],

  // check mark
  check: [
    ['path', {d: 'M5 12.5l4.5 4.5L19 7.5'}],
  ],

  // padlock
  lock: [
    ['rect', {x: 5, y: 11, width: 14, height: 10, rx: 2}],
    ['path', {d: 'M8 11V8a4 4 0 0 1 8 0v3'}],
    ['line', {x1: 12, y1: 15, x2: 12, y2: 17}],
  ],

  // buildings (city)
  building: [
    ['rect', {x: 4, y: 3, width: 10, height: 18, rx: 1.2}],
    ['path', {d: 'M14 9h4.8A1.2 1.2 0 0 1 20 10.2V21'}],
    ['line', {x1: 7.5, y1: 7, x2: 10.5, y2: 7}],
    ['line', {x1: 7.5, y1: 11, x2: 10.5, y2: 11}],
    ['line', {x1: 7.5, y1: 15, x2: 10.5, y2: 15}],
  ],

  // sparkles
  sparkles: [
    ['path', {d: 'M10 4l1.6 4.4L16 10l-4.4 1.6L10 16l-1.6-4.4L4 10l4.4-1.6z'}],
    ['path', {d: 'M18 14l.8 2.2L21 17l-2.2.8L18 20l-.8-2.2L15 17l2.2-.8z'}],
  ],

  // leaf
  leaf: [
    ['path', {d: 'M5 19c0-9 5-14 14-14 0 9-5 14-14 14z'}],
    ['line', {x1: 5, y1: 19, x2: 13, y2: 11}],
  ],

  // trending up (chart)
  trendUp: [
    ['path', {d: 'M3 17l6-6 4 4 8-8'}],
    ['path', {d: 'M15 7h6v6'}],
  ],

  // credit card
  card: [
    ['rect', {x: 3, y: 6, width: 18, height: 13, rx: 2.5}],
    ['line', {x1: 3, y1: 10.5, x2: 21, y2: 10.5}],
    ['line', {x1: 6.5, y1: 15, x2: 10, y2: 15}],
  ],

  // flame
  flame: [
    ['path', {d: 'M12 3s5.5 4 5.5 9.5a5.5 5.5 0 0 1-11 0c0-2.2 1-3.8 2.6-5.3.2 1.7 1 2.6 2 2.9C10.8 8.4 11 5.6 12 3z'}],
  ],

  // bell
  bell: [
    ['path', {d: 'M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15z'}],
    ['path', {d: 'M10 20.5a2 2 0 0 0 4 0'}],
  ],

  // magnifying glass
  search: [
    ['circle', {cx: 11, cy: 11, r: 6.5}],
    ['line', {x1: 16, y1: 16, x2: 20.5, y2: 20.5}],
  ],

  // location pin
  pin: [
    ['path', {d: 'M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z'}],
    ['circle', {cx: 12, cy: 10, r: 2.4}],
  ],
};

// 'bolt' is the same drawing as 'electric' (used for "heavy driver")
ICON_SHAPES.bolt = ICON_SHAPES.electric;